// extracted by extract-css-chunks-webpack-plugin
module.exports = {"title-default":"_2T2xPc","title-small":"_2ix4DX"};